// VERSION : 0.0.1
// AUTHOR : VIGNESH
// LAST EDIT : VIGNESH
// MODIFIED DATE: 07-12-2025
// LAST CHANGED : ADDED COMMENT LINES

/* eslint-disable import/no-anonymous-default-export */
import DataVerificationReportActionTypes from './data-verification-report.type';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getDataVerificationReportListResponse: null,
	getDataVerificationReportListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/****************  GET DATA VERIFICATION REPORT LIST END *********************** */
		case DataVerificationReportActionTypes.GET_DATA_VERIFICATION_REPORT_LIST_SUCCESS:
			return {
				...state,
				getDataVerificationReportListResponse: action.payload,
				getDataVerificationReportListArr: docodeHexResponse(
					action.payload,
					'DataVerificationReportKey',
				),
			};

		case DataVerificationReportActionTypes.GET_DATA_VERIFICATION_REPORT_LIST_FAILURE:
			return { ...state, getDataVerificationReportListResponse: action.payload };

		case DataVerificationReportActionTypes.GET_DATA_VERIFICATION_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, getDataVerificationReportListResponse: null };
		/****************  GET DATA VERIFICATION REPORT LIST END *********************** */
		default:
			return state;
	}
};
